export default { sha: '5dea1db045bc3e8957ca13ee65ccdd99947f6088', buildNumber: 'undefined' }
